import { useAuth } from '../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Archive, LogOut, Globe, Search, Shield } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/', label: 'Extractor', icon: Archive },
  { path: '/domain-checker', label: 'Domain Check', icon: Globe },
  { path: '/keyword-search', label: 'Keyword Search', icon: Search },
  { path: '/history-check', label: 'History Check', icon: Shield },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="h-14 border-b border-zinc-200 bg-white flex items-center px-4 sm:px-6" data-testid="navbar">
      <div className="flex items-center gap-2.5 mr-6">
        <Archive className="w-5 h-5 text-zinc-950" />
        <span className="text-base font-bold tracking-tight font-heading text-zinc-950 hidden sm:inline">Archive Extractor</span>
      </div>
      <div className="flex items-center gap-1">
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const active = location.pathname === item.path ||
            (item.path === '/' && location.pathname.startsWith('/jobs/'));
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-sm transition-colors ${
                active
                  ? 'bg-zinc-900 text-white font-medium'
                  : 'text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900'
              }`}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <Icon className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">{item.label}</span>
            </button>
          );
        })}
      </div>
      <div className="ml-auto flex items-center gap-3">
        {user && (
          <>
            <span className="text-sm text-zinc-500 font-body hidden sm:inline" data-testid="user-name">
              {user.name || user.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              className="text-zinc-500 hover:text-zinc-900"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 mr-1.5" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </>
        )}
      </div>
    </nav>
  );
}
